import { Component, OnInit, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { Guid } from '../core/guid';
import { TxtAttach } from '../core/txtattach.model';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { PictureService } from './picture.service';
import { EAttachment } from '../core/eattachment.model';
import { Picture } from './picture.model';
import { Pictureupdate } from './pictureupdate.model';
import {NgxImageCompressService} from 'ngx-image-compress';
interface imageattachfile {
    SignatureId: string;
    ImageDataJson: string;
    ImageFileName: string;
}
@Component({
    selector: 'app-picture',
    templateUrl: './picture.component.html',
    styleUrls: ['./picture.component.css']
})
export class PictureComponent implements OnInit {

    @ViewChild('fileInput') el: ElementRef;

    //formdata
    message: string;
    isError: boolean;
    isAlert: boolean;
    public showLoading: boolean = true;
    signnewid: Guid;
    signdata: string;
    isWarning: boolean;
    isAlertSuccess: boolean;
    signpadhidden: boolean;
    previewPic: boolean;
    stringifiedData: any;
    txtattach: TxtAttach;
    isPDFEnable: boolean = true;
    isDisabled: boolean = false;
    signaturePad: any;
    pictureForm: FormGroup;
    mandateAll: boolean = true;
    FName: string;
    LName: string;
    isNameEnable: boolean;
    image: string;
    video: string;
    file: string;
    videoData: any;
    imageFile: string;

    fileToUpload: any;
    imageUrl: any;


    editFile: boolean = true;
    removeUpload: boolean = false;

    fileName:string;
    mydata = [];
    myCompressdata = [];
    imageFileAttach: Array<EAttachment>=[];
    picture: Picture[];
    imagearray: Array<imageattachfile> = [];
    pictureupdate: Pictureupdate[];

    //compress
    localUrl: any;
    localCompressedURl: any;
    sizeOfOriginalImage: number;
    sizeOFCompressedImage: number;
    imgResultBeforeCompress: string;
    public imgResultAfterCompress: string=null;
    isSingle:boolean = false;

    constructor(private route: ActivatedRoute,
        private fb: FormBuilder,
        private router: Router,
        private ref: ChangeDetectorRef,
        private sanitizer: DomSanitizer,
        private PictureService: PictureService,
        private cd: ChangeDetectorRef,
        private imageCompress: NgxImageCompressService
    ) {
        route.params.subscribe(val => {
            let id = (this.route.snapshot.params['signId']) ? this.route.snapshot.params['signId'] : '';
            this.signnewid = id;           
        });  
        
        route.queryParams.subscribe(val => {
            console.log(val.single);
            this.isSingle = val.single=="true" ? true : false ;            //#added for CRM 161337 Daniel.ab
            console.log(this.isSingle);     
        });


    }
    
   

    ngOnInit(): void {
        this.isAlertSuccess = false;
        this.signpadhidden = true;
        this.previewPic = true;
        this.isValidSignature(this.signnewid);
        this.formGroup();
        this.imageUrl = '../../assets/IconImg/Placeholder.jpg';

    }
    //imageCaptureData = [{
    //    SignatureID: null,
    //    ImageDataJson: '',
    //    ImageFileName: null,
    //}];
    imageCaptureData = [{
        SignatureID: null,
        ImageData: '',
        ImageFileName: null,
    }];
    formGroup() {
        this.pictureForm = this.fb.group({
            SignatureID: Guid,
            TxtAttaches: this.fb.array([])

        });
       
    }
    Attach(): FormGroup {
        return this.fb.group({
            SignatureID: null,
            ImageDataJson: null,
            ImageFileName: null,
           
        });
    }
    handleFileInput(file: FileList) {
        this.fileToUpload = file.item(0);

        //Show image preview
        let reader = new FileReader();
        reader.onload = (event: any) => {
            this.imageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
    }

    isValidSignature(id) {
        this.showLoading = false;
        if (id != "") {
            this.FName = "",
                this.LName = "";
            this.PictureService.getisValidSign(id)
                .then(response => {
                    this.showLoading = false;
                    this.signpadhidden = false;
                    this.previewPic = true;
                    if (response) {                       
                        this.showLoading = false;
                        if (response.IsValid == true) {
                            this.isDisabled = false;
                            if (response.Custom2 == '1') {
                                this.signpadhidden = true;
                                this.previewPic = true;
                                this.showAlert("Not Authorized", true, true);
                                console.log("Already Image Submitted");
                                this.isAlertSuccess = true;
                            }

                        } else {
                            this.invalidResponse();
                            console.log("Time out", response.IsValid);
                        }
                    } else {
                        this.invalidResponse();
                        console.log("Signature ID InValid");
                    }
                }).catch(error => {
                    this.showAlert(error, true);
                    this.showLoading = false;
                });
        } else {
            this.signIDValidate(id);
            console.log("Signature ID InValid in onload");
        }
    }


    signIDValidate(id) {
        if (id == "") {
            this.isDisabled = true;
            this.signpadhidden = true;
            this.previewPic = true;
            this.showAlert("Not Authorized", true, true);

        }
    }

    invalidResponse() {
        this.isDisabled = true;
        this.isNameEnable = true;
        this.showAlert("Not Authorized", true, true);
    }
    //uploadFile(event) {
    //    this.showLoading = true;
    //    this.signpadhidden = true;
    //    this.previewPic = false;
    //    let reader = new FileReader(); // HTML5 FileReader API
    //    let file = event.target.files[0];
    //    if (event.target.files && event.target.files[0]) {
    //        this.fileName = file.name;
    //        reader.readAsDataURL(file);

    //        // When file uploads set it to file formcontrol
    //        reader.onload = () => {
    //            this.imageUrl = reader.result;
    //            this.pictureForm.patchValue({
    //                file: reader.result
    //            });
    //            this.imageFile = reader.result;
    //            this.editFile = false;
    //            this.removeUpload = true;
    //        }
    //        // ChangeDetectorRef since file is loading outside the zone
    //        this.cd.markForCheck();
    //    }
    //}

    //// Function to remove uploaded file
    //removeUploadedFile() {
    //    let newFileList = Array.from(this.el.nativeElement.files);       
    //    this.editFile = true;
    //    this.removeUpload = false;
    //    this.pictureForm.patchValue({
    //        file: [null]
    //    });
    //}
    onSelectFile(event) {        
        this.showLoading = true;
        this.onFileSelected(event);
        this.showLoading = false;
        this.signpadhidden = true;
        this.previewPic = false;
      
    }
    onFileSelected(event) {
        const files = event.target.files;
        if (files) {
            for (const file of files) {
                const reader = new FileReader();
                reader.onload = (e: any) => {
                    //console.log(e.target.result);
                    this.localUrl = e.target.result;
                    //let compressImage = this.compressFile(this.localUrl, file.name)
           
                    if (file.type.indexOf("image") > -1) {
                        this.mydata.push({
                            url: this.localUrl,
                            type: 'img',
                            filename: file.name
                        });
                    }
                    this.previewPic = false;
                    let compressImage = this.compressFile(this.localUrl, file.name);
                };
                reader.readAsDataURL(file);
                //let compressImage = this.compressFile(this.localUrl, file.name);
             

            }
        }
    }
   //compress
     compressFile(image, fileName) {
         var orientation = -1;
        this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
        //console.warn('Size in bytes is now:', this.sizeOfOriginalImage);
         this.imageCompress.compressFile(image, orientation, 30, 30).then(
             result => {
                 this.imgResultAfterCompress = result;
                 this.localCompressedURl = result;
                 this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024)
                 //console.warn('Size in bytes after compression:', this.sizeOFCompressedImage);
                 // create file from byte
                 const imageName = fileName;
                 // call method that creates a blob from dataUri
                 const imageBlob = this.dataURItoBlob(this.imgResultAfterCompress.split(',')[1]);
                 //imageFile created below is the new compressed file which can be send to API in form data
                 const imageFile = new File([result], imageName, { type: 'image/jpeg' });
                 //console.log(imageBlob);
                 this.myCompressdata.push({
                     url: result,
                     type: 'img',
                     filename: fileName
                 });
             })
    }
    dataURItoBlob(dataURI) {
        const byteString = window.atob(dataURI);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: 'image/jpeg' });
        return blob;
    }
    submitSign() {
        this.showLoading = true;
        this.signpadhidden = true;
        this.previewPic = true;
        this.submitSignature();
    }
 
     async submitSignature() {
               
        if (!this.isDisabled) {
            if (this.signnewid != "") {
                if (this.myCompressdata  == null) {
                    //console.log('if', this.imageFile );
                    this.showAlert("Please Select Image for Send", true, true);
                } else {
                    // for ImageData 
                    this.imageCaptureData = [];
                    this.pictureupdate = [];

                    let signid = this.signnewid.toString();
                    for (var i = 0; i < this.myCompressdata.length; i++)  {
                        var obj = {
                            SignatureID: this.signnewid.toString(),
                            ImageData: this.myCompressdata[i].url,
                            ImageFileName: this.myCompressdata[i].filename,

                        }

                        this.pictureupdate.push(obj);
                    }
                   
                    //this.stringifiedData = JSON.stringify(this.pictureupdate);
                   
                    this.PictureService.saveSignature(this.pictureupdate)
                        .subscribe(response => {
                            console.log(response);
                            if (response) {
                               
                                this.signdata = response.toString();
                                this.isAlertSuccess = true;
                                this.signpadhidden = true;
                                this.previewPic = true;
                                this.showAlert("Uploaded Successfully", false);
                                this.showLoading = false;
                            }
                        }),
                        error => {
                            this.showAlert(error, true);
                            this.isAlertSuccess = true;
                            this.signpadhidden = true;
                            this.previewPic = true;
                            this.showAlert("Upload Failed", true, true);
                            this.showLoading = false;
                        }
                }

            } else {
                this.signIDValidate(this.signnewid);
            }
        }
    }
    CloseSuccess() {
        window.close();
    }
    oncancelUpload() {
        this.mydata=[];
        this.previewPic = true;
        this.signpadhidden = false;
    }
    // Show Alert

    showAlert(strMsg: string, isErr: boolean, showWarning: boolean = false) {
        this.isAlert = true;
        this.isError = isErr;
        this.isWarning = showWarning;
        this.message = strMsg;
    }

    // Close Alert

    closeAlert() {
        this.isAlert = false;
    }
}



// WEBPACK FOOTER //
// ./SignClient/app/picture/picture.component.ts